import { MarketExplorer } from '@/features/market/MarketExplorer';
import { SimulateurTabs } from '@/features/simulations/SimulateurTabs';

export function SimulateurMarchePage() {
  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-2xl font-semibold">Simulateur</h1>
      <SimulateurTabs />
      <MarketExplorer />
    </div>
  );
}
